"use client";var l=l=>"string"==typeof l?"ds-global-cta--".concat(l):null!=l&&l.brand&&null!=l&&l.colour?"ds-".concat(null==l?void 0:l.brand,"-cta--").concat(null==l?void 0:l.colour):void 0;export{l as default};
